<form class="form" *ngIf="articleModel">
  <div class="input-group">
    <label>Sticky links title</label
    ><input
      pInputText
      type="text"
      placeholder="Title"
      [(ngModel)]="articleModel.stickyLinksTitle"
      name="stickyLinksTitle"
    />
  </div>
</form>
<p-table [value]="articleModel.stickyLinks">
  <ng-template pTemplate="header">
    <tr>
      <th>Text</th>
      <th>Link</th>
      <th>Icon</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-link let-rowIndex="rowIndex">
    <tr>
      <td>
        {{ link.text }}
      </td>
      <td>
        {{ link.link }}
      </td>
      <td>
        <div class="icon">
          <img [src]="'/titleSvgs/' + link.icon" alt="icon" />
        </div>
      </td>
      <td class="buttons">
        <button
          pButton
          icon="pi pi-pencil"
          label="update"
          class="update"
          (click)="updateLink(link)"
        ></button>
        <button
          pButton
          icon="pi pi-trash"
          label="delete"
          class="delete"
          (click)="deleteLink(link)"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    <tr>
      <td colspan="4">
        <button
          pButton
          class="p-button-success"
          label="Add link"
          icon="pi pi-plus"
          (click)="createLink()"
        ></button>
      </td>
    </tr>
  </ng-template>
</p-table>
